export const goldenafternoon = {
  name: 'Golden Afternoon',
  color: [0.803921568627451, 0.7450980392156863, 0.6549019607843137, 1],
  bg: [0.5333333333333333, 0.1411764705882353, 0.14901960784313725, 1],
  grid1: [0.19607843137254902, 0.18823529411764706, 0.18823529411764706, 1],
  grid2: [0.7607843137254902, 0.5843137254901961, 0.27058823529411763, 1],
}
